<template>
  <div class="contenedor">
    <div class="row">
      <div class="col-12" v-if="!loading && oliverwords">

          <!-- BlackList General -->
          <Fieldset title="BlackList General" :mykey="222">
              <div>
                <IndividualWordEditor
                :words="blacklistGeneral"
                @save="saveBlacklist"
                ></IndividualWordEditor>
              </div>
        </Fieldset>

        <Fieldset title="EMAIL TAGs" :mykey="2">
          <div class="bg-light p-3" v-for="area in allwords" :key="area.type">
            <label>{{ area.label }}</label>
            <WordsEditor
              :desc="area.desc"
              :type="area.type"
              :words="oliverVariableData(area.type)"
              :use-buffered-words="true"
            ></WordsEditor>
          </div>
        </Fieldset>
      </div>
    </div>
    <div class="dropdown-divider mt-4 mb-4"></div>
    <Fieldset title="Category Linkedin Detection" :mykey="3">
      <div class="row mt-4">
        <div class="col-12">
          <label>
            Label
            <input type="text" v-model="newtitle" />
          </label>
          <br />
          Words
          <textarea
            type="text"
            class="form-control"
            v-model="newwords"
            rows="5"
          >
          </textarea>
          <button
            :disabled="!newwords || !newtitle"
            @click="insertNew('level')"
            class="btn btn-sm btn-primary mt-2"
          >
            {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>
      <div v-for="level in levels" class="row">
        <div class="col-12 bg-light p-3" v-if="level.id != 12013">
          <label
            >{{ level.label }}
            <i
              v-if="editnow != level.id"
              class="icon-pencil text-primary ml-1 cursor-pointer"
              @click="editnow = level.id"
            ></i>
            <i
              v-if="editnow == level.id"
              class="icon-close text-danger ml-1 cursor-pointer"
              @click="editnow = false"
            ></i>
          </label>
          <div v-if="editnow != level.id">
            <small
              v-for="word in levelwords[level.id].split(',')"
              class="text-lowercase  bg-secondary text-white mx-1"
            >
              |{{ word }}|
            </small>
          </div>
          <div class="bg-light p-3" v-if="editnow == level.id">
            <textarea
              type="text"
              class="form-control"
              v-model="levelwords[level.id]"
              rows="5"
            >
            </textarea>
            <button
              class="mt-2 btn btn-sm btn-primary"
              @click="saveWordsLevel(level.id)"
            >
              {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>
      </div>
      <div class="dropdown-divider mt-4 mb-4"></div>
      <h4 class="mb-3">Function</h4>
      <div class="row mt-4">
        <div class="col-12">
          <label>
            Label
            <input type="text" v-model="newtitle" />
          </label>
          <br />
          Words
          <textarea
            type="text"
            class="form-control"
            v-model="newwords"
            rows="5"
          >
          </textarea>
          <button
            :disabled="!newwords || !newtitle"
            @click="insertNew('function')"
            class="btn btn-sm btn-primary mt-2"
          >
            {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>

      <div v-for="level in functs" class="row">
        <div class="col-12 bg-light p-3" v-if="level.id != 12013">
          <label
            >{{ level.label }}
            <i
              v-if="editnow != level.id"
              class="icon-pencil text-primary ml-1 cursor-pointer"
              @click="editnow = level.id"
            ></i>
            <i
              v-if="editnow == level.id"
              class="icon-close text-danger ml-1 cursor-pointer"
              @click="editnow = false"
            ></i>
          </label>

          <div v-if="editnow != level.id">
            <small
              v-for="word in functionwords[level.id].split(',')"
              class="text-lowercase bg-secondary text-white mx-1"
            >
              |{{ word }}|
            </small>
          </div>
          <div class="bg-light p-3" v-if="editnow == level.id">
            <textarea
              type="text"
              class="form-control"
              v-model="functionwords[level.id]"
              rows="5"
            >
            </textarea>
            <button
              class="mt-2 btn btn-sm btn-primary"
              @click="saveWordsFunction(level.id)"
            >
              {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>
      </div>
    </Fieldset>
    <Fieldset class="mt-2" title="Target - Price" :mykey="827" v-if="!loading">
      <div class="row mt-4">
        <div class="col-12">
          <label> Price <input type="text" v-model="newprice" /> </label>
          <br />

          <button
            :disabled="!newprice"
            @click="insertNewPrice(newprice)"
            class="btn btn-sm btn-primary mt-2"
          >
            {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>
    </Fieldset>
    <Fieldset
      class="mt-2"
      title="Target - Keywords"
      :mykey="828"
      v-if="!loading"
    >
      <div class="row mt-4">
        <div class="col-4">
          <select v-model="categoryKey" class="d-inline form-control">
            <option
              v-for="item in categories_jobs_group.filter(
                e => e.category != 'Custom_Job_Titles'
              )"
              :key="item.category"
              :value="item"
              class="optionSelect"
              :class="{
                'text-primary': item.category === 'Custom_Job_Titles',
                'font-weight-bold': item.category === 'Custom_Job_Titles'
              }"
            >
              {{ $t("lang.category_job_group." + item.category) }}
            </option>
          </select>

          <!-- <button class="btn btn-sm btn-primary mt-2">
            {{ $t("lang.button.save") }}
          </button> -->
        </div>
        <div class="col-8">
          <WordsEditor
            :desc="categoryKey.category ? categoryKey.category : ''"
            :id="categoryKey.id"
            :type="'targetKeyword'"
            :words="categoryKey.words"
            @update="updateCategoryJobs($event)"
          ></WordsEditor>
        </div>
      </div>
    </Fieldset>
  </div>
</template>
<script>
import { adminService, clientsService } from "@/_services";
import Fieldset from "@/components/Common/Fieldset.vue";
import WordsEditor from "@/components/Common/WordsEditor.vue";
import IndividualWordEditor from "@/components/Common/IndividualWordEditor.vue";

import { mapState } from "vuex";

export default {
  components: {
    Fieldset,
    WordsEditor,
    IndividualWordEditor
  },

  data() {
    return {
      allwords: [
        {
          desc: "Oliver OFF + (Auto Reply + Auto Follow Up)",
          label: this.$t("lang.refuse.negativewords"),
          type: "negativewords"
        },
        {
          desc: "Tag",
          label: this.$t("lang.refuse.positivewords"),
          type: "positivewords"
        },
        { 
          desc: "Tag",
          label: "Urgent",
          type: "manualpositivewords"
        },
        { desc: "Tag", label: "Introduction Words", type: "introductionwords" },
        {
          desc: "Oliver OFF + Tag",
          label: this.$t("lang.refuse.automaticwords"),
          type: "automaticwords"
        },
        {
          desc: "Oliver ON + Do not contact + Tag",
          label: this.$t("lang.refuse.stopwords"),
          type: "stopwords"
        },
        {
          desc: "Oliver ON + Tag",
          label: this.$t("lang.refuse.spamwords"),
          type: "spamwords"
        },
        {
          desc: "Oliver ON + Delete contact (ATTENTION)",
          label: this.$t("lang.refuse.notworkingwords"),
          type: "notworkingwords"
        },
        { desc: "Oliver OFF + Tag", label: "Scope Words", type: "scopewords" },
        {
          desc: "Oliver ON + OFF contact in this opp + Future Recalls",
          label: this.$t("lang.refuse.wrongwords"),
          type: "wrongwords"
        },
        {
          desc: "Mark as Bounce",
          label: "Rejected words",
          type: "rejectedwords"
        },
        {
          desc:
            "Email ignored (The system check only FROM, for example: unsubcribe@gmail.com)",
          label: "Not valid words",
          type: "novalidwords"
        }
      ],
      functs: [],
      levels: [],
      editnow: "",
      functionwords: [],
      levelwords: [],
      blacklistGeneral: [],
      newwords: "",
      newtitle: "",
      loading: false,
      categoryKey: "",
      categoriesJobs: []
    };
  },
  computed: {
    ...mapState({
      categories_jobs_group: state =>
        state.optionsList.all["category_jobs_group"].data
    }),
  },
  created() {
    this.getOliverSettings();
    adminService.getOliverVariables("price").then(result => {
      this.newprice = result[0].data;
    });
    this.categoriesJobs = this.categories_jobs_group;
  },

  methods: {
    oliverVariableData(name) {
      const s = this.oliverwords;
      if (!s || !name) {
        return "";
      }
      const fromWords = s.words && s.words[name];
      if (fromWords && typeof fromWords === "object" && "data" in fromWords) {
        const d = fromWords.data;
        return d == null ? "" : String(d);
      }
      const fromPrompts = s.prompts && s.prompts[name];
      if (fromPrompts && typeof fromPrompts === "object" && "data" in fromPrompts) {
        const d = fromPrompts.data;
        return d == null ? "" : String(d);
      }
      const legacy = s[name];
      if (typeof legacy === "string") {
        return legacy;
      }
      return "";
    },
    getOliverSettings() {
      this.loading = true;
      adminService.getOliverSettings({wordListComplete: true}).then(response => {
        this.oliverwords = response;
        if(response.blacklist_general != null)  this.blacklistGeneral = response.blacklist_general.words.map( e => ({ ...e, markForDeletion: false}));
        this.functs = response.functions;
        this.levels = response.levels;
        this.levels.forEach(l => {
          this.levelwords[l.id] = l.words;
        });
        this.functs.forEach(f => {
          this.functionwords[f.id] = f.words;
        });
        this.loading = false;
      });
    },
    saveBlacklist(){
        //('saveing blacklist...');
        const domains = {
          client_id: 1,
          listWords: true,
          words: this.blacklistGeneral
        }
        clientsService.importWord(domains)
        .then((result) => {
          if(result){
            this.getOliverSettings();
            //console.log('data blacklist... saved.');
          }
        });
    },
    saveWordsLevel(id) {
      adminService.updateWords(this.levelwords[id], id);
    },
    saveWordsFunction(id) {
      adminService.updateWords(this.functionwords[id], id);
    },
    insertNewPrice(newprice) {
      let type = "price";
      adminService.updateOliverVariables(this.newprice, type).then(res => {
       // console.log(this.newprice);
      });
    },

    insertNew(type) {
      adminService.insertNew(this.newwords, this.newtitle, type).then(res => {
        this.newwords = "";
        this.newtitle = "";
        this.getOliverSettings();
      });
    },

    updateCategoryJobs(event) {
      this.categories_jobs_group.map(element => {
        if ((element.id = event.id)) {
          element.words = event.words;
        }
      });
    }
  }
};
</script>
